import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Target, Shield, Heart } from 'lucide-react';
const benefits = [{
  title: 'Build Confidence',
  description: 'Watch your child stand taller and speak clearer. We help students overcome challenges and believe in themselves.',
  icon: Trophy,
  color: 'text-yellow-400'
}, {
  title: 'Focus & Discipline',
  description: 'Developing the ability to listen, follow directions, and focus on tasks - skills that translate directly to better grades.',
  icon: Target,
  color: 'text-[#00D4FF]'
}, {
  title: 'Self-Defense Skills',
  description: 'Practical, effective techniques to keep you and your family safe. Empowerment through preparation and awareness.',
  icon: Shield,
  color: 'text-[#FF6B35]'
}, {
  title: 'Anti-Bullying',
  description: 'We teach kids how to avoid conflict, use their voice, and defend themselves only when absolutely necessary.',
  icon: Heart,
  color: 'text-red-400'
}];
export function BenefitsSection() {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-22">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gray-50 -skew-x-12 translate-x-20 z-0" data-id="element-23" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-24">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-25">
          <h2 className="text-3xl md:text-5xl font-bold text-black mb-4 tracking-tight" data-id="element-26">
            Why Choose Walker's?
          </h2>
          <div className="w-20 h-1 bg-[#00D4FF] mx-auto mb-6" data-id="element-27" />
          <p className="text-lg text-gray-600" data-id="element-28">
            Martial arts is about more than just kicking and punching. It's
            about personal growth, character development, and building a strong
            foundation for life.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-29">
          {benefits.map((benefit, index) => <motion.div key={benefit.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white p-8 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl hover:border-[#00D4FF]/30 transition-all group" data-id="element-30">
              <div className={`w-14 h-14 rounded-lg bg-gray-50 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`} data-id="element-31">
                <benefit.icon className={`w-8 h-8 ${benefit.color}`} data-id="element-32" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#00D4FF] transition-colors" data-id="element-33">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-34">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}